import React from "react";
import { AppBar, Toolbar, Grid, Container } from "@material-ui/core";
import LocaleSelectorModal from "../common/LocaleSelectorModal";
import LocaleSelectorMenu from "./LocaleSelectorMenu";
import HeaderBranding from "./HeaderBranding";

const Header: React.FC = () => {
  return (
    <AppBar
      style={{ backgroundColor: "black", color: "white" }}
      position="relative"
    >
      <LocaleSelectorModal />
      <Toolbar variant="dense" disableGutters>
        <Container maxWidth="md">
          <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="center"
          >
            <Grid item>
              <HeaderBranding />
            </Grid>
            <Grid item>
              <LocaleSelectorMenu />
            </Grid>
          </Grid>
        </Container>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
